import { useAuth } from 'app/provider/auth'
import { SaveOfferButton } from './save-offer-button'
import { useCreateSavedOffer, useDeleteSavedOffer } from './commands'
import { ButtonProps } from '@my/ui'
import { useCallback, useState } from 'react'

export interface SaveOfferButtonContainerProps {
  offerId: string
  isBookmarked: boolean
  size?: number
  color?: string
  buttonProps?: ButtonProps
}

export const SaveOfferButtonContainer = (props: SaveOfferButtonContainerProps) => {
  const { user } = useAuth()
  const [bookmarked, setBookmarked] = useState(props.isBookmarked)

  const [createSavedOffer, { loading: creatingOffer }] = useCreateSavedOffer()
  const [deleteSavedOffer, { loading: deletingOffer }] = useDeleteSavedOffer()

  const handlePress = useCallback(async () => {
    if (creatingOffer || deletingOffer) {
      return
    }

    if (bookmarked) {
      await deleteSavedOffer({
        variables: {
          offerId: props.offerId,
        },
      })
    } else {
      await createSavedOffer({
        variables: {
          offerId: props.offerId,
        },
      })
    }
    setBookmarked(!bookmarked)
  }, [bookmarked, props.offerId]);

  // If the user is not logged in, don't render anything
  // as we don't want to show the button to anonymous users
  // because they can't save offers
  if (!user) {
    return null
  }

  return (
    <SaveOfferButton
      offerId={props.offerId}
      loading={creatingOffer || deletingOffer}
      saved={bookmarked}
      size={props.size}
      color={props.color}
      onPress={handlePress}
    />
  )
}
